import React from 'react';
import { BusinessSection } from './components/BusinessSection';
import { CompanySection } from './components/CompanySection';
import { DeliverySection } from './components/DeliverySection';
import { FloatingSupport } from './components/FloatingSupport';
import { Hero } from './components/Hero';
import { LegalSections } from './components/LegalSections';
import { ProductsSection } from './components/ProductsSection';
import { RefundsSection } from './components/RefundsSection';
import { SiteFooter } from './components/SiteFooter';
import { SiteNav } from './components/SiteNav';
import { SupportSection } from './components/SupportSection';
import { TeamSection } from './components/TeamSection';
export function App() {
  return <div id="top" className="min-h-screen w-full bg-ink font-sans text-base leading-[1.65] text-fg antialiased" data-id="element-0" data-mp="2wifc12o1ootf">
      <SiteNav data-id="element-1" data-mp="28sb9yzqi8x4j" />
      <main data-id="element-2" data-mp="23vcjqs9ypabm">
        <Hero data-id="element-3" data-mp="23vktwcepa1j4" />
        <CompanySection data-id="element-4" data-mp="23w4e5zrtp20b" />
        <TeamSection data-id="element-5" data-mp="23utcq6luo6cd" />
        <BusinessSection data-id="element-6" data-mp="23t8g8bfz6dbv" />
        <ProductsSection data-id="element-7" data-mp="3ik7fqfdqo9q4" />
        <DeliverySection data-id="element-8" data-mp="3iiwdwl3utc1n" />
        <RefundsSection data-id="element-9" data-mp="3ijftvw9y1qd1" />
        <SupportSection data-id="element-10" data-mp="3ii4qvyobommz" />
        <LegalSections data-id="element-11" data-mp="3ml13n8r6loj0" />
      </main>
      <SiteFooter data-id="element-12" data-mp="3mjzsl4a6121a" />
      <FloatingSupport data-id="element-13" data-mp="3mjgannkimdn9" />
    </div>;
}